<template>
    <span class="ds-tag" :class="[colorClass]">
        {{ label }}
    </span>
</template>

<script>
const allowedColors = ['grey', 'green', 'blue', 'yellow', 'orange', 'red', 'purple', 'dark-grey', 'dark-green', 'dark-blue', 'dark-yellow', 'dark-orange', 'dark-red', 'dark-purple'];

/**
 * Tag Component
 *
 * @example
 * ```js
 * import { DsTag } from '../../atoms';
 *
 * export default {
 *   components: { DsTag },
 *   template:
 *   `<div>
 *     <DsTag label="This is a tag" />
 *     <DsTag label="Colored tag" color="green" />
 *   </div>`
 * }
 * ```
 */
export default {
    name: 'DsTag',
    props: {
        label: { type: String, default: '' },
        color: { type: String, default: 'grey', validator: value => !value || allowedColors.includes(value) }
    },
    computed: {
        colorClass () {
            return this.color ? `ds-tag--${this.color}` : null;
        }
    }
};
</script>
